<template>
    <div v-click-outside='outsideClick' :class='{ on: open }' class='ui-select'>
        <button :disabled='disabled' type='button' @click='open = !open'>
            <span class='txt' v-html='selected'></span>
        </button>
        <ul style='z-index: 1000;'>
            <input type='text'
                @input='onChange($event)'
                class='singleline-ellipsis-new'
                placeholder='검색'
            >
            <li
                v-for='(txt, index) in selectDataNew'
                :key='index'
                :class='{ on: selectedIndex === index }'
                class='singleline-ellipsis'
                @click='changeData(txt, index)'
                v-html='txt'
            ></li>
        </ul>
    </div>
</template>

<script>
import EventBus from '../assets/js/eventBus';

export default {
    name: 'SelectForm',
    props: {
        selectData: Array,
        selectValue: {
            type: Array,
            default: () => [],
        },
        selectedValue: [String, Number, Object],
        disabled: {
            default: false,
            type: Boolean,
        },
    },
    data() {
        return {
            open: false,
            selected: '',
            selectedIndex: '',
            selectDataNew: this.selectData,
            selectValueNew: [],
        };
    },
    watch: {
        selectedValue(v) {
            if (this.selectedValue !== undefined) {
                const index = this.selectValue.findIndex(value => value === this.selectedValue);
                this.selectedIndex = index;
                this.selected = this.selectData[index];
            }
        },
    },
    mounted() {
    },
    updated() {
        if (this.selectedValue !== undefined) {
            const index = this.selectValue.findIndex(value => value === this.selectedValue);
            this.selectedIndex = index;
            this.selected = this.selectData[index];
        }
    },
    created() {
        const index = 0;
        this.selectedIndex = index;
        this.selected = this.selectData[index];

        if (this.selectedValue !== undefined) {
            const index = this.selectValue.findIndex(value => value === this.selectedValue);
            this.selectedIndex = index;
            this.selected = this.selectData[index];
        }

        // 컴포넌트간의 데이터 교환, select-form 초기화, selectData중 가장 첫번째 항목 선택
        EventBus.$on('event:initList', (value) => {
            this.selected = this.selectData[0];
        });

        this.selectDataNew = this.selectData;
        this.selectValueNew = this.selectValue;
    },
    methods: {
        changeData(txt, index) {
            this.open = false;
            this.selected = txt;
            this.selectedIndex = index;

            // console.log(txt);
            // console.log(index);

            this.$emit('update:selectedValue', this.selectValueNew[index]);
            this.$emit('update:set', this.selectValueNew[index], index);
            this.$emit('update:selected', this.selectDataNew[index]);
        },
        outsideClick() {
            this.open = false;
        },
        onChange(e) {
            this.selectDataNew = [];
            this.selectValueNew = [];
            const searchText = e.target.value;
            this.selectData.forEach((item,index) => {
                if( item.includes(searchText) ) {
                    this.selectDataNew.push(item);
                    this.selectValueNew.push(this.selectValue[index]);
                }
            });
        },
    },
};
</script>
<style lang='scss' scoped>
@import '../assets/scss/mixin.scss';

.ui-select {
    display: inline-block;
    position: relative;
    width: 160px;
    height: 32px;

    & + .ui-select {
        margin-left: 8px;
    }

    &.on {
        ul {
            display: block;
        }
    }

    button {
        display: block;
        overflow: hidden;
        position: relative;
        width: 100%;
        height: 32px;
        padding-left: 8px;
        border: 1px solid #ced4da;
        border-radius: 4px;
        font-size: 14px;
        line-height: 30px;
        text-align: left;
        color: #7e7777;

        &:disabled {
            background: #f1f5f7;
        }

        &:focus {
            outline: 0;
        }

        &::after {
            content: '';
            position: absolute;
            right: 8px;
            top: 8px;

            @include ic-tri-arrow;
        }

        .txt {
            display: block;
            overflow: hidden;
            padding-right: 20px;
        }
    }

    ul {
        display: none;
        position: absolute;
        left: 0;
        top: 33px;
        width: 100%;
        padding: 12px 0;
        background: #fff;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
        z-index: 1;
        overflow-y: auto;
        max-height: 240px;

        li {
            display: block;
            height: 100%;
            padding: 0 22px;
            font-size: 13px;
            line-height: 25px;
            color: #545454;
            cursor: pointer;
            margin-bottom: 10px;

            &.on {
                background-color: rgba(0, 199, 229, 0.1);
            }

            &:hover {
                background-color: rgba(0, 199, 229, 0.1);
            }
        }
    }

    &.full {
        width: 100%;
        height: 44px;

        button {
            height: 44px;
            padding-left: 25px;
            border: 0;
            line-height: 44px;

            &::after {
                top: 16px;
                right: 35px;
            }
        }

        ul {
            top: 46px;
        }
    }
}
</style>
<style scoped>
.singleline-ellipsis {
    white-space: pre-line;
}
.singleline-ellipsis-new {
    /* width: 556px; */
    margin-left: 22px;
    margin-bottom: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
